import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../contexts/authContext";
import "../solar/solar-model.scss";

const BejelentkezesModel = () => {
  const { currentUser, login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const tokenExpiration = localStorage.getItem("tokenExpiration");
    if (
      currentUser &&
      tokenExpiration &&
      new Date().getTime() < tokenExpiration
    ) {
      navigate("/f9a3c2dd20d43eda5d3e522ba2b79dfc");
    }
  }, [currentUser, navigate]);

  useEffect(() => {
    if (currentUser) {
      navigate("/f9a3c2dd20d43eda5d3e522ba2b79dfc");
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    try {
      await login(data.get("felhasznalonev"), data.get("jelszo"));
      navigate("/f9a3c2dd20d43eda5d3e522ba2b79dfc");
    } catch (error) {
      console.error("Failed to login", error);
    }
  };

  const defaultTheme = createTheme();

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Bejelentkezés
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="felhasznalonev"
              label="Felhasználónév"
              name="felhasznalonev"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="jelszo"
              label="Jelszó"
              type="password"
              id="jelszo"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}>
              Bejelentkezés
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default BejelentkezesModel;
